$(document).ready(function() {

  $('body').on('submit','.js-validate-form__inner-page', function (e) {
    if (e.isDefaultPrevented()) {
      // handle the invalid form...
    } else {
      $.ajax({
        type: "POST",
        url: $('.js-validate-form__inner-page').attr('action'),
        data: $('.js-validate-form__inner-page').serialize(),
        dataType: 'json',
        success: function(data){
          if(data.status == "success"){
            $('.js-validate-form__inner-page .msg-success').removeClass('hidden');
            $('.js-validate-form__inner-page input:not(.js-validate-form__inner-page--send)').val("");
            $('.js-validate-form__inner-page .newslatter-input_area').val("");
  
            setTimeout(function() {
              $('.js-validate-form__inner-page .msg-success').addClass('hidden');
            }, 3000);
          }else{
  
          }
        }
      });
    }
    return false;
  });

});
